module.exports = __webpack_public_path__ + "static/media/JD.75312246.svg";